/* eslint-disable import/no-anonymous-default-export */
import { Descriptions } from "antd";
import styled from "styled-components";

const ContainerKeyboardInfo = styled.div`
  margin-top: 0.5rem;
`;

export default () => {
  return (
    <ContainerKeyboardInfo>
      <Descriptions
        labelStyle={{ color: "var(--primary-color)" }}
        size="small"
        layout="vertical"
        style={{ fontSize: 10 }}
        bordered={true}
        title="Atajos de teclado"
      >
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Anterior imagen"
        >
          Flecha izquierda
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Siguiente imagen"
        >
          Flecha derecha
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Escribir patente"
        >
          CTRL + P
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Marcar extranjero"
        >
          F10
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Marcar patente ilegible y descartar infracción"
        >
          F12
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Moverse entre las imagenes de la infracción"
        >
          F2
        </Descriptions.Item>
        <Descriptions.Item
          labelStyle={{ fontWeight: "bold" }}
          label="Renombrar"
        >
          ENTER
        </Descriptions.Item>
        {/* <Descriptions.Item labelStyle={{ 'fontWeight': 'bold' }} label="Anterior página">CTRL + Flecha izquierda</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold' }} label="Siguiente página">CTRL + Flecha derecha</Descriptions.Item> */}
      </Descriptions>
    </ContainerKeyboardInfo>
  );
};
